import { fork, put, take, takeLatest } from 'redux-saga/effects';
import { selectAPI } from '../../../api/API.sagas';
import {
    API_DELETE_PAYMENT_METHOD,
    API_DELETE_PAYMENT_METHOD_SUCCESS,
    API_GET_PAYMENT_METHOD,
    API_GET_PAYMENT_METHOD_SUCCESS,
    API_PUT_PAYMENT_METHOD,
    API_PUT_PAYMENT_METHOD_SUCCESS
} from '../../../api/lendingAPI/LendingAPI.actions';
import { getPaymentMethod } from '../../../api/lendingAPI/PaymentAPIHelper';
import { CLOSE_MODAL, OPEN_MODAL } from '../../../iwModals/Modals.actions';
import {
    DELETE_DEBIT_CARD,
    DELETE_DEBIT_CARD_PENDING,
    EDIT_DEBIT_CARD,
    EDIT_DEBIT_CARD_COMPLETED,
    EDITING_DEBIT_CARD,
    UPDATE_DEBIT_CARD,
    UPDATE_DEBIT_CARD_PENDING
} from './EditPaymentMethodModal.actions';

export const editDebitCardSagaWorkers = [fork(editDebitCard)];

function* editDebitCard() {
    yield takeLatest(EDIT_DEBIT_CARD, function* (action) {
        const { payment_method } = yield selectAPI();
        const paymentMethod = getPaymentMethod(
            payment_method,
            action.paymentMethodID
        );

        yield put({ type: EDITING_DEBIT_CARD, paymentMethod });
        yield put({ type: OPEN_MODAL, id: 'EditPaymentMethodModal' });

        const nextAction = yield take([
            CLOSE_MODAL,
            DELETE_DEBIT_CARD,
            UPDATE_DEBIT_CARD
        ]);

        switch (nextAction.type) {
            case DELETE_DEBIT_CARD:
                yield put({ type: DELETE_DEBIT_CARD_PENDING });
                yield deleteDebitCard(nextAction.paymentMethodID);
                break;
            case UPDATE_DEBIT_CARD:
                const { paymentMethodID, repaymentRole, fundingRole } =
                    nextAction;
                yield put({ type: UPDATE_DEBIT_CARD_PENDING });
                yield updateDebitCard(
                    paymentMethodID,
                    repaymentRole,
                    fundingRole
                );
        }
    });
}

function* updateDebitCard(paymentMethodID, repaymentRole, fundingRole) {
    const body = JSON.stringify({
        data: {
            roles: {
                repayment: repaymentRole,
                funding: fundingRole
            }
        }
    });

    yield put({
        type: API_PUT_PAYMENT_METHOD,
        paymentMethodID,
        body
    });

    yield take(API_PUT_PAYMENT_METHOD_SUCCESS);

    yield put({ type: API_GET_PAYMENT_METHOD });
    yield take(API_GET_PAYMENT_METHOD_SUCCESS);

    const { payment_method } = yield selectAPI();
    yield put({ type: EDIT_DEBIT_CARD_COMPLETED, payment_method });
    yield put({ type: CLOSE_MODAL });
}

function* deleteDebitCard(paymentMethodID) {
    yield put({
        type: API_DELETE_PAYMENT_METHOD,
        paymentMethodID: paymentMethodID
    });

    yield take(API_DELETE_PAYMENT_METHOD_SUCCESS);

    yield put({ type: API_GET_PAYMENT_METHOD });
    yield take(API_GET_PAYMENT_METHOD_SUCCESS);

    const { payment_method } = yield selectAPI();
    yield put({ type: EDIT_DEBIT_CARD_COMPLETED, payment_method });
    yield put({ type: CLOSE_MODAL });
}
